
export const RoleArray = [
    'user_band0',
    'user_band1',
    'user_band2',
    'user_band3',
    'pro_band0',
    'pro_band1',
    'pro_band2',
    'pro_band3',
    'pro_keeper',
    'anonymous',
] as const

export type Role = typeof RoleArray[number]


export const USER_ROLES: Role[] = [
    'user_band0',
    'user_band1',
    'user_band2',
    'user_band3',
]

export const PRO_ROLES: Role[] = [
    'pro_band0',
    'pro_band1',
    'pro_band2',
    'pro_band3',
    'pro_keeper',
]